import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowLeft18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M0.939331 9.00001L7.46966 15.5303L8.53032 14.4697L3.81065 9.75L17 9.75001V8.25001L3.81066 8.25L8.53032 3.53034L7.46966 2.46968L0.939331 9.00001Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowLeft18.displayName = 'ArrowLeft18';
export default ArrowLeft18;
